module.exports = __webpack_public_path__ + "static/media/ico-loading-blue-and-yellow-small.2c849522.gif";